import React, { createContext, useState, useContext } from "react";

const BreadcrumbsContext = createContext();

export const useBreadcrumb = () => useContext(BreadcrumbsContext);

export const BreadcrumbProvider = ({ children }) => {
    const [breadcrumb, setBreadcrumb] = useState({
        eventName: null,
    });

    return (
        <BreadcrumbsContext.Provider value={{ breadcrumb, setBreadcrumb }}>
            {children}
        </BreadcrumbsContext.Provider>
    );
};